import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Label, Button, Form, Input } from "reactstrap";
import axios from "axios";
import { loaderAction, successModalToggle } from "../../../redux/actions/Index";
import { useForm } from "react-hook-form";
import _ from "lodash";
import BarCharts from "../../../components/Chart/BarCharts";
import error from '../../../images/errortable.gif';
import { environment } from "../../../env";
import { BeatLoader } from "react-spinners";
import LoadBox from "../../../components/Loading/LoadBox";
import HorizontalBarChart from "../../../components/Chart/HorizontalBarChart";
const Dashboard = () => {
  const [projectLabelName, setProjectLabelName] = useState();
  const [soldBuilding, setSoldBuilding] = useState([]);
  const [rentBuilding, setRentBuilding] = useState([]);
  const [loading, setLoading] = useState(true);
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch()
  var selectProject = watch('project');
  var projectRentSell = watch('projectRentSell');
  useEffect(() => {
    if (projectRentSell == 2) {
      setLoading(true)
      let loadertimer = setTimeout(() => {
        // setLoading(false)
      }, 3200);
      return () => clearTimeout(loadertimer)
    }
  }, [projectRentSell])
  useEffect(() => {
    let loadertimer = setTimeout(() => {
      setLoading(false)
    }, 3200);
    return () => clearTimeout(loadertimer)
  }, [])



  const projectName = (e) => {
    const datas = projectList?.filter((val, i) => {
      return (val.id == e.target.value)
    }
    )
    setProjectLabelName(datas[0].name)
  }
  const projectName1 = () => {
    const datas = projectList?.filter((val, i) => {

      return (val.default == true)
    }
    )
    setProjectLabelName(datas[0]?.name)
    reset({ "project": datas[0]?.id })
  }
  useEffect(() => {
    if (projectList) {
      projectName1()
    }
  }, [projectList])


  const keys = ['Unsold', 'Self', 'Sold']
  const keys1 = ['Vacant', 'Rent']
  var rentbuilding = []

  const buildingchartt = async (rentdata, project) => {

    await axios.get(`${environment.baseUrl}proposal-investors/`).then((res) => {
      rentbuilding = res.data;
    })
    try {
      var rentbardata = []

      rentdata?.map((rent) => {
        rentbardata?.push({ "id": rent.id, "building": rent.building, "Vacant": rent.Unsold + rent.Sold + rent.Self, "Rent": 0 })
        rentbuilding?.map((tenant) => {
          if (tenant.investor.building.building_no == rent.building && tenant.proposal.status == 'Approved') {
            rentbardata[rentbardata.length - 1].Vacant = parseFloat(parseFloat(rentbardata[rentbardata.length - 1].Vacant - parseFloat(tenant.required_area)).toFixed(2));
            rentbardata[rentbardata.length - 1].Rent = parseFloat(parseFloat(rentbardata[rentbardata.length - 1].Rent + parseFloat(tenant.required_area)).toFixed(2));
          }
        })
      })


      setRentBuilding(rentbardata)
    } catch (err) {
      console.log(err)
    }
  }

  const buildingpiechart = async (project) => {
    var filterbuilding = []
    if (project) {
      filterbuilding = buildingList?.filter((filterBuilding) => filterBuilding?.project?.id == project);
    }
    const buildingPieChartURL = `${environment.baseUrl}project-sold-gala/${project}`;
    dispatch(loaderAction())
    setLoading(true)
    try {
      setSoldBuilding([])
      var buildingchart = []
      await axios.get(buildingPieChartURL).then((buildingresponse) => {
        var soldGala = buildingresponse.data;
        var soldBarData = [];
        for (let i = 0; i < soldGala.length; i++) {
          if (soldBarData.findIndex((e) => e.building === soldGala[i].building.building_no) === -1 && soldGala[i].Investors.name == 'Sumeet Logistics LLP') {
            soldBarData.push({
              id: soldGala[i].building.building_no,
              building: soldGala[i].building.building_no,
              Unsold: parseFloat((parseFloat(soldGala[i].building.area_builtup) - (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2)),
              Sold: 0,
              Self: parseFloat((parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area)).toFixed(2)),
            })

          } else if (soldGala[i].Investors.name == 'Sumeet Logistics LLP') {
            let index1 = soldBarData.findIndex((e) => e.building === soldGala[i].building.building_no)
            soldBarData[index1].Unsold = parseFloat((parseFloat(soldBarData[index1].Unsold) - (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2));
            soldBarData[index1].Self = parseFloat((soldBarData[index1].Self + (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2))
          }
          else if (soldBarData.findIndex((e) => e.building === soldGala[i].building.building_no) === -1) {
            soldBarData.push({
              id: soldGala[i].building.building_no,
              building: soldGala[i].building.building_no,
              Unsold: parseFloat((parseFloat(soldGala[i].building.area_builtup) - (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2)),
              Sold: parseFloat((parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area)).toFixed(2)),
              Self: 0
            })
          } else {
            let index = soldBarData.findIndex((e) => e.building === soldGala[i].building.building_no)
            soldBarData[index].Unsold = parseFloat((parseFloat(soldBarData[index].Unsold) - (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2))
            soldBarData[index].Sold = parseFloat((soldBarData[index].Sold + (parseFloat(soldGala[i].sold_gala_area) - parseFloat(soldGala[i].resell_area))).toFixed(2))
          }
        }
        buildingchartt(soldBarData, project);
        for (let i = 0; i < filterbuilding.length; i++) {
          if (soldBarData.findIndex((e) => e.building === filterbuilding[i].building_no) === -1) {
            soldBarData.push({
              id: filterbuilding[i].building_no,
              building: filterbuilding[i].building_no,
              Unsold: parseFloat(filterbuilding[i].area_builtup),
              Sold: 0,
              Self: 0
            })
          }
        }
        soldBarData.sort((a, b) => {
          if (a.building < b.building) { return 1; }
          if (a.building > b.building) { return -1; }
          return 0;
        })
        setSoldBuilding(soldBarData);
      })
    }
    catch (err) {
      dispatch(loaderAction())
      console.log("error", err)
    }
    setLoading(false)
  };

  useMemo(() => { setProjectLabelName(projectLabelName) }, [projectLabelName])

  useEffect(() => {
    if (selectProject) {
      buildingpiechart(selectProject);
    }
  }, [selectProject, projectRentSell]);

  return (
    <>
      <div className="dashboard-main">
        <div className="dashboard-body">
          <Form >
            <div className='my-4 row'>
              <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("project", { required: true, onChange: (e) => { projectName(e) } })}
                  >
                    <option value="" >Project Name</option>
                    {projectList?.map((data, i) => {
                      return <option value={data.id} key={i} selected={data.id == userProject}>{data.name}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                <div className="mt-1  d-flex gap-3">
                  <select
                    id="role_type"
                    name="role_type"
                    className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                    {...register("projectRentSell")}
                  >
                    <option value="1">Rent Buildings</option>
                    <option value="2">Sell Buildings</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
          <br />
        </div>
        {
          loading ? <div className="bg-white p-5 rounded-5 mb-5">
            <div className=" pb-2">
              <div className="" style={{ height: "350px", width: "100%" }}>
                <LoadBox />
              </div>
            </div>
          </div> :
            rentBuilding.length > 0 && projectRentSell == 1 &&
            <div className="bg-white p-5 rounded-5 mb-5">
              <div className="border-bottom pb-2">
                <div className="d-flex justify-content-between align-items-center px-5 ">
                  <h1 className='mb-0 title-font-bold '>Rent Buildings</h1>
                  <h1 className='mb-0 title-font-bold text-base-color text-capitalize'>{projectLabelName}</h1>
                </div>
                <div className="" style={{ height: "2000px", width: "100%" }}>
                  {(rentBuilding.length > 0 && (rentBuilding[0]?.Vacant > 0 || rentBuilding[0]?.Rent > 0)) ?
                    <HorizontalBarChart noOfGalaList={rentBuilding} keys={keys1} xaxis={"Buildings"} /> : <div className="d-flex justify-content-center align-items-center px-5 h-100">
                      <h1 className='mb-0 title-font-bold text-secondary text-capitalize'>No Data Present in graph...! </h1>
                    </div>}
                </div>
              </div>
            </div>
        }
        {projectRentSell == 2 && !loading &&
          <div className="bg-white p-5 rounded-5 mb-5">
            <div className="">
              <div className="d-flex justify-content-between align-items-center px-5 ">
                <h1 className='mb-0 title-font-bold '>Sell Buildings</h1>
                <h1 className='mb-0 title-font-bold text-base-color text-capitalize'>{projectLabelName}</h1>
              </div>
              <div className="" style={{ height: "2000px", width: "100%" }}>
                {(soldBuilding.length > 0 && (soldBuilding[0]?.Unsold > 0 || soldBuilding[0]?.Self > 0 || soldBuilding[0]?.Sold > 0)) ?
                  <HorizontalBarChart noOfGalaList={soldBuilding} keys={keys} xaxis={"Buildings"} /> :
                  <div className="d-flex justify-content-center align-items-center  py-5 flex-column  bg-white">
                    <div className="w-25">
                      <img src={error} alt="" className="img-fit" />
                    </div>
                    <h1 className="text-base-color title-font-700 text-capitalize">No Data Present in graph...</h1>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </>
  )
}

export default Dashboard